export const initialOtpState = { values: [] };
export function otpReducer(state, action) {
    const { payload } = action;
    const newValues = [...state.values];
    switch (action.type) {
        case 'ADD_VALUE':
            newValues[payload.index] = payload.value ? payload.value : '';
            return { values: newValues };
        case 'REMOVE_VALUE':
            newValues.pop();
            return { values: newValues };
        case 'REMOVE_VALUE_BY_INDEX':
            newValues.splice(payload.index, 1);
            return { values: newValues };
        case 'REPLACE_VALUE_BY_INDEX':
            newValues[payload.index] = '';
            return { values: newValues };
        case 'RESET_VALUES':
            return { values: [] };
        case 'ADD_PASTE_VALUE':
            return { values: payload === null || payload === void 0 ? void 0 : payload.copiedValue };
        default:
            throw new Error();
    }
}
//# sourceMappingURL=OtpState.js.map